// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import { Link } from 'react-router-dom';
import { parseDuration } from '../../../../../../../lib/utility';
import { LabModule as LabModuleType } from '../../../../../../../types/Model';

import { S } from './styles';

interface LabModuleProps {
  active: boolean;
  module: LabModuleType;
  to: string;
}

const LabModule: React.FC<LabModuleProps> = (props):JSX.Element => {
  const {
    active,
    module: {
      name,
      type,
      duration,
      status,
    },
    to
  } = props;

  return (
    <S.Container>
      <S.Link as={Link} to={to} active={active}>
        <S.TitleContainer>
          <S.Icon type={type}/>
          <S.Title>{name}</S.Title>
        </S.TitleContainer>
        <S.FooterContainer>
          {duration && <S.DurationText>{parseDuration(duration).auto}</S.DurationText>}
          {status && <S.CompletionStatusTag type={status}/>}
        </S.FooterContainer>
      </S.Link>
    </S.Container>
  );
}

export { LabModule as default };
